import Records from "@/services/records";

export default {
    data() {
        return {
            PENDING_STATUS: 0,
            APPROVE_STATUS: 1,
            REJECT_STATUS: 2,
            COMPLETED_STATUS: 3,
            VETSOURCE: "vetsource",
            PETCARE: "petcare",
            selectedRequest: null
        };
    },
    methods: {
        getStatusLabel(item, codeOnly = false) {
            if (item.completed_at)
                return codeOnly
                    ? this.COMPLETED_STATUS
                    : "<span>Completed</span>";
            if (item.status == this.PENDING_STATUS)
                return codeOnly
                    ? this.PENDING_STATUS
                    : "<strong>Pending</strong>";
            if (item.status == this.APPROVE_STATUS)
                return codeOnly ? this.APPROVE_STATUS : "<span>Approved</span>";
            if (item.status == this.REJECT_STATUS)
                return codeOnly ? this.REJECT_STATUS : "<span>Denied</span>";
        },
        extractRequestParams(rec) {
            let mapChannel = {
                PETCARE: 1,
                VETSOURCE: 2
            };

            let key = rec?.channel ?? "";
            key = key.toUpperCase();
            let channel = mapChannel[key] ?? null;

            let vetSourceItemType = null;
            if (channel === 2) {
                vetSourceItemType = rec?.item_type;
            }

            return {
                ...rec,
                recordId: rec?.id,
                clientId: rec?.client_id,
                clientName: rec?.client?.display_name ?? rec?.client?.name,
                patientId: rec?.patient_id,
                patientName: rec?.patient?.display_name ?? rec?.patient?.name,
                itemId: rec?.item_id,
                itemName: rec?.item?.display_name ?? rec?.item?.name,
                denyReasons: rec?.denial_reasons,
                ptBreed: rec?.patient.breed_species,
                ptWeight: rec?.patient.weight,
                ptAge: rec?.patient.age,
                itemPackaging: rec?.item?.packaging,
                itemStrength: rec?.item?.strength,
                isClinicalRationaleRequired:
                    rec?.isClinicalRationaleRequired ?? false,
                clinicalRationales: rec?.clinicalRationales ?? [],
                channel,
                vetSourceItemType
            };
        },
        onSuccessAction() {
            this.$emit("reload-tab-count");
            this.getList();
        },
        approveRequest(record) {
            if (record.channel.toLowerCase() == this.VETSOURCE) {
                let params = this.extractRequestParams(record);
                this.$refs.modalApproveRequest.open(params);
            } else {
                this.processRefillRequest(record, "APPROVE");
            }
        },
        denyRequest(record) {
            if (record.channel.toLowerCase() == this.VETSOURCE) {
                let params = this.extractRequestParams(record);
                this.$refs.modalDenyRequest.open(params);
            } else {
                this.processRefillRequest(record, "REJECT");
            }
        },
        processRefillRequest(record, mode) {
            const errorMessage = "Error: Unable to get refill request details";

            Records.getRecordRefillRequest(record.id)
                .then(response => {
                    if (response.message.code == 200) {
                        this.selectedRequest = response.resource;

                        if (this.selectedRequest.status == this.PENDING_STATUS)
                            this.$refs.modalApproveRejectRequestRefill.open(
                                this.selectedRequest,
                                mode
                            );
                    } else {
                        this._message(errorMessage, "danger");
                    }
                })
                .catch(error => {
                    this._message(errorMessage, "danger");
                    console.error(error);
                });
        },
        viewItemDetail(item) {
            this.$refs.modalDetailRequest.open(item);
        }
    }
};
